import * as React from "react";
import { Theme, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { fetchData } from "../common/services/ApiClient";
import { ApiBaseUrl } from "../config";

const useStyles = makeStyles((theme: Theme) => ({
  resultRunDate: {
    color: theme.palette.primary.main,
    textAlign: "center",
    fontSize: ".875rem",
    lineHeight: ".875rem",
    marginTop: ".5rem",
    marginBottom: "1rem",
    width: "100%",
  },
}));

export default function ResultRunDate() {
  const classes = useStyles();
  const [dataAsOf, setDataAsOf] = React.useState("");
  React.useEffect(() => {
    if (!dataAsOf) {
      let isMounted = true;
      (async () => {
        await fetchData(
          `${ApiBaseUrl()}/institutions?filters=ACTIVE:1&limit=0`,
        )
          .then(response => {
            if (isMounted) {
              setDataAsOf(
                new Date(response.createTimestamp).toLocaleDateString(),
              );
            }
          })
          .catch((error: Error) => {
            console.error(error);
          });
      })();
      return () => {
        isMounted = false;
      };
    }
  }, [dataAsOf]);

  return (
    <Typography className={classes.resultRunDate} id="result-data-date">
      {`Data as of: ${dataAsOf}`}
    </Typography>
  );
}
